import React, { Component } from "react";
import SingleGame from "../SingleGame/SingleGame";
import "./GameList.scss";
import GameListDisplay from "./GameList.styled";

export default class GameList extends Component {
  render() {
    const { games } = this.props;
    ////console.log("games" , games.lenght)
    const gamesList = games.map((i, k) => {
      ////console.log("i" , i.name)
      return (
        <SingleGame
          key={`games-${k}`}
          img={i.img}
          name={i.name}
          namrAr={i.name_ar}
          gameID={i.id}
          category={this.props.category}
        ></SingleGame>
      );
    });
    ////console.log(gamesList)
    return <GameListDisplay>{gamesList}</GameListDisplay>;
  }
}
